import ReactSlider from "react-slider";
import styles from "./index.module.css";
import { useEffect, useState } from "react";

const RangeSlider = ({
  min,
  max,
  step = 1,
  defaultValue = 0,
  onChange,
}: any) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (value: string) => {
    setValue(value);
    onChange(value);
  };
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <>
      <ReactSlider
        className={styles.slider}
        thumbClassName={styles.thumb}
        trackClassName={styles.track}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(value) => handleChange(value)}
      />
      <input
        className="w-[60px] py-1 text-center text-sm border border-solid border-lightgrey outline-none"
        type="number"
        name="rangeValue"
        id="rangeValue"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      />
    </>
  );
};

export default RangeSlider;
